import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import BookingForm from '../components/booking/BookingForm';
import s from '../styles/pages/PrivateEvents.module.css';
import site from '../data/master.json';

export default function PrivateEvents() {
  return (
    <div className={s.container}>
      <Header />
      <BookingForm />
      <Footer data={site.footer} />
    </div>
  );
}